module.exports = __webpack_public_path__ + "static/media/close.51e4ab08.svg";